export default __webpack_public_path__ + "static/media/entrefox_logo.49d27d37.png";